var map = {
	"./drinking.svg": 437,
	"./exercise.svg": 438,
	"./lsc_top2.svg": 439,
	"./meal.svg": 440,
	"./obesity.svg": 441,
	"./rest.svg": 442,
	"./smoking.svg": 443
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;


//////////////////
// WEBPACK FOOTER
// ./src/images/lsc ^\.\/.*\.svg$
// module id = 436
// module chunks = 0